<template>
  <PlayerPage :loading="loading" :white="false"
    :mode="player" @changeMode="player = $event">
    <title-bar>異世界創造</title-bar>
    <keep-alive :include="/Area/">
      <router-view v-model="form" 
        :postMessage="postMessage"
        :iconList="iconList"
        :worlds="worlds"
        :importCard="importCard"
        @submit="onSubmit"
        @test="onSubmit(true)"
        @changePlayer="player = $event"
      />
    </keep-alive>
  </PlayerPage>
</template>

<script>
import { phina, canvasInit } from '@/canvas'
import store from '@/store'
import PlayerPage from '@/components/PlayerPage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import _ from 'lodash'
export default {
  components: {
    PlayerPage,
    TitleBar
  },
  data () {
    return {
      loading: false,
      form: {
        world: {},
        area: {},
        test: {
          account:[]
        },
        card: [],
      },
      postMessage: {},
      iconList:[],
      worlds: [],
      importCard: [],
      player: 'n-player'
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.form.world = response.world
      this.form.area = response.area
      this.form.test = response.test
      this.form.card = response.card
      this.iconList = response.iconList
      this.form.id = this.$route.params.id
      this.worlds = response.worlds
      this.importCard = response.importCard
    },
    onSubmit (test) {
      this.$store.dispatch('setWorldEdit', _.assign({},this.form,{doTest:test}))
        .then((response) => {
          if(response.error === '200 OK'){
            if(test){
              this.$router.push({ path:'/result' })
            }else{
              this.postMessage = response
              this.form.id = response.id
              this.form.world = response.world
              this.form.area = response.area
              this.form.test = response.test
              this.form.card = response.card
            }
          }
        })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getWorldEdit', route.params.id)
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    this.checkLogin()
    this.$store.dispatch('setCode', [])
  },
  mounted () {
    phina.main(canvasInit);
    // phina.global.app.currentScene.exit('TitleScene')
  }
}
</script>

<style lang="scss" scoped>
</style>
